module.exports = __webpack_public_path__ + "components/flag/static/square/bm-d6202ce6fd023ca7928b19c83b7c95c6.svg";